import { render, staticRenderFns } from "./SplitCellModal.vue?vue&type=template&id=6d33935f"
import script from "./SplitCellModal.vue?vue&type=script&lang=js"
export * from "./SplitCellModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports